var map = {
	"./new_h_adult002.json": [
		12317,
		2317
	],
	"./new_h_default.json": [
		84840,
		4840
	],
	"./new_h_default_eur.json": [
		49383,
		9383
	],
	"./new_h_default_gbp.json": [
		44618,
		4618
	],
	"./new_h_essential.json": [
		68838,
		8838
	],
	"./new_h_habit002.json": [
		65656,
		5656
	],
	"./new_h_names002.json": [
		48039,
		8039
	],
	"./new_h_names003.json": [
		58795,
		8795
	],
	"./new_h_names004.json": [
		75716,
		5716
	],
	"./new_h_read003b.json": [
		99546,
		9546
	],
	"./new_h_reading.json": [
		71550,
		1550
	],
	"./new_h_seniors_o.json": [
		36403,
		6403
	],
	"./new_h_seniors_s.json": [
		87363,
		7363
	],
	"./new_h_student.json": [
		55607,
		5607
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 65053;
module.exports = webpackAsyncContext;